import { IUser } from '@boma/administration-portal/shared/entities';
import { createReducer, on, Action } from '@ngrx/store';
import * as UserActions from './user.actions';

export const USER_FEATURE_KEY = 'user';

export interface UserState extends IUser {
  error?: string | null;
  loaded: boolean;
}

export const userIntialState: UserState = {
  id: '',
  firstName: '',
  surname: '',
  roles: [],
  updatedAt: null,
  createdAt: null,
  error: '',
  loaded: false,
};

const usersReducer = createReducer(
  userIntialState,
  on(UserActions.loadUserSuccess, (state, { payload }) => ({
    ...payload,
    loaded: true,
  })),
  on(UserActions.loadUserFailure, (state, { error }) => ({
    ...state,
    error,
  }))
);

export function userReducer(state: UserState | undefined, action: Action) {
  return usersReducer(state, action);
}
